import { err, ok } from 'neverthrow';
import { Assert } from '../../../../../utilities/src';
import { Ty } from '../../ty';
import { SpecialForm } from './types';
import { c } from './combinators';
import { CompileOutput } from '../eraql-ast/ast';
import _ from 'lodash';

const bang: SpecialForm = ([arg], ctx) => {
  Assert.assert(arg !== undefined, 'already checked arity');

  return c.Ty(arg, ctx).map((res) => ({
    item: { t: 'ty', ty: Ty.nn(res) },
    bindings: {},
  }));
};

const ARRAY: SpecialForm = ([arg], ctx) => {
  Assert.assert(arg !== undefined, 'Artiy already checked');
  return c.Ty(arg, ctx).map((type) => ({
    item: {
      t: 'ty',
      ty: Ty.ty(Ty.a(type)),
    },
    bindings: {},
  }));
};

const RECORD: SpecialForm = ([arg], ctx) => {
  Assert.assert(arg !== undefined, 'Artiy already checked');
  return c.Ty(arg, ctx).map((type) => ({
    item: {
      t: 'ty',
      ty: Ty.ty(Ty.record(type)),
    },
    bindings: {},
  }));
};

const RANGE: SpecialForm = (args, ctx, func) =>
  c
    .Args(c.NumLit, c.NumLit)(args, ctx, func)
    .map(([start, stop]) => ({
      item: { t: 'ty', ty: Ty.ty(Ty.range(start, stop)) },
      bindings: {},
    }));

const ENUM: SpecialForm = (args, _ctx) => {
  const variants: string[] = [];

  for (const [arg, argMeta] of args) {
    if (arg.t !== 'literal' || typeof arg.val !== 'string') {
      return err([[{ t: 'invalid-enum-variant' }, argMeta]]);
    }
    variants.push(arg.val);
  }

  return ok({
    item: { t: 'ty', ty: Ty.ty(Ty.enumOf(variants)) },
  });
};

const STRUCT: SpecialForm = (args, ctx, op) =>
  c
    .Args(c.RecordOf(c.Ty))(args, ctx, op)
    .map(
      ([res]): CompileOutput => ({
        item: {
          t: 'ty',
          ty: Ty.ty(Ty.structOf(_.mapValues(res, (x) => x.v[0]))),
        },
      })
    );

const TAG: SpecialForm = (args, ctx, op) =>
  c
    .Args(c.Ty, c.StringLit)(args, ctx, op)
    .map(([ty, tag]) => ({ item: { t: 'ty', ty: Ty.tag(ty, [tag]) } }));

export const TY_SPECIAL_FORMS: Record<
  string,
  [arity: number | 'any', fn: SpecialForm]
> = {
  '!': [1, bang],
  ARRAY: [1, ARRAY],
  TAG: [2, TAG],
  RECORD: [1, RECORD],
  RANGE: [2, RANGE],
  ENUM: ['any', ENUM],
  STRUCT: [1, STRUCT],
};
